/* AIRSHOT fade-in vid scroll. Klassen läggs via JS, utan JS syns allt. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = [
    '.ah-eyebrow', '.ah h2', '.ah-body', '.ah-lead', '.ah-btn',
    '.ah-steps__head', '.ah-step', '.ah-icons__item', '.ah-ed__item', '.ah-prod__img',
    '.ah-usp__row', '.ah-split__img', '.ah-split__txt', '.ah-faq__head', '.ah-faq details',
    '.ah-nm__head', '.ah-nm__cmp', '.ah-nm__lead', '.ah-nm__form',
    '.ah-trust__list > *',
    '.swr__eyebrow', '.swr__h', '.swr__sum'
  ].join(',');
  function inFirstScreen(el) {
    return el.getBoundingClientRect().top < (window.innerHeight || 800) * 0.92;
  }
  function init() {
    var main = document.getElementById('MainContent') || document;
    var els = Array.prototype.slice.call(main.querySelectorAll(SEL)).filter(function (el) {
      if (el.closest('.ah-hero, .shop-product-section, [class*="product-info"]') && !el.closest('.ah-trust')) return false;
      if (el.closest('.ah-rv')) return false;
      return !inFirstScreen(el);
    });
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        t.classList.add('ah-rv--in');
        io.unobserve(t);
        setTimeout(function () { t.classList.remove('ah-rv', 'ah-rv--in'); t.style.removeProperty('--ah-rv-d'); }, 1300);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var seen = new Map();
    els.forEach(function (el) {
      var p = el.parentNode, i = seen.get(p) || 0;
      seen.set(p, i + 1);
      el.style.setProperty('--ah-rv-d', Math.min(i, 5) * 80 + 'ms');
      el.classList.add('ah-rv');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
